const getState = state => state.sort;

export default {
  getState,
};
